import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Col, Row } from 'react-bootstrap';
import config from '../../config';
import { Grid } from "@material-ui/core";
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Snackbar from 'material-ui/Snackbar';
import MenuItem from 'material-ui/MenuItem/MenuItem';
import Paper from 'material-ui/Paper';
import Pagination from 'materialui-pagination';
import DateTimePicker from 'material-ui-datetimepicker';
import Divider from 'material-ui/Divider';
import DatePickerDialog from 'material-ui/DatePicker/DatePickerDialog'
import TimePickerDialog from 'material-ui/TimePicker/TimePickerDialog';
import TextField from 'material-ui/TextField';
import SelectField from "material-ui/SelectField";
import Chip from 'material-ui/Chip';
import Checkbox from 'material-ui/Checkbox';
import InfoIcon from 'material-ui/svg-icons/action/info';
import Dialog from 'material-ui/Dialog';
import {
    red100,
    red800,
    grey300,
    grey900,
} from 'material-ui/styles/colors';
import {
	Table,
	TableBody,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableRowColumn
} from 'material-ui/Table';
import ArrowUpward from 'material-ui/svg-icons/navigation/arrow-upward'
import ArrowDownward from 'material-ui/svg-icons/navigation/arrow-downward'
import SwapVert from 'material-ui/svg-icons/action/swap-vert'

import _ from 'lodash';
import moment from 'moment';

import {
    getCampaignById,
    getAllGroups,
    updateCampaign,
    getContactsInCampaign,
    getSupportedTimeZones,
    getCampaignBot,
    deleteCampaign,
    getCampaignContacts,
} from '../../reducers/campaign/resources';
import templateResources from '../../reducers/templates/resources';
import session from '../../utils/session';
import formatterUtil from '../../utils/format';
import mixpanel from '../../utils/mixpanel';

import './index.css';

import { evaluateTCPA } from '../../utils/tcpa';

class ViewCampaign extends Component {

    componentWillMount = async () => {
        const {campaignId} = this.props.match.params;
        const sessionPageData = (session.get(campaignId) || {});

        this.setState({
            campaign: {},
            name: '',
            schedule: '',
            groupId: '',
            message: '',
            campaignName: '',
            campaignPrivacy: false,
            schedule: '',
            timezone: '',
            templateId: '',
            now: '',
            isActive: false,
            status: '',
            isEdit: false,
            expanded: false,
            templates: [],
            groups: [],
            contacts: [],
            timezones: [],
            showSnackBar: false,
            snackBarMessage: '',
            scheduleError: '',
            total: 0,
            rowsPerPage: [5, 10, 15, 20, 25, 50, 100],
            page: 1,
            numberOfRows: 20,
            filter: sessionPageData.filter || 'all',
            showDeleteDialog: false,
            sortBy: 'updated_at',
            sortDirection: 'ASC',
            totalContacts: 0,
            cursorPosition: 0,
            notificationUsers:[],
            no_slots_message: ''
        });

        let paginate = JSON.stringify({
			rowsPerPage: [5, 10, 15, 20, 25, 50, 100],
			contacts: [],
			numberOfRows: sessionPageData.numberOfRows || 20,
			page: sessionPageData.page || 1,
			total: sessionPageData.total || 0,
		});

        let campaign = {};

        try {
            campaign = await getCampaignById(
                campaignId, { "field": (sessionPageData.filter || 'all') }, paginate, {column: 'updated_at', order: 'ASC'});
        } catch (error) {
            this.setState({
                showSnackBar: true,
                snackBarMessage: "Please check the broadcast later."
            });
        }

        const groups = await getAllGroups();
        const templates = await templateResources.getTemplates();
        const timezones = await getSupportedTimeZones();
        const userRole = session.get('userData').role || '';
		const isAdmin = userRole === config.userRoles.ghAdmin;

        let campaignContacts;
        if (campaign.data.status) {
            // Campaign finished. Get contacts from get-campaign-contacts endpoint
            campaignContacts = await getCampaignContacts(
                campaignId,
                paginate,
                JSON.stringify({
                    column: 'updated_at', order: 'ASC'})
            );
        } else {
            // Campaign has not started. Get contacts from get-contact endpoint
            campaignContacts = await getContactsInCampaign(
                campaignId,
                paginate,
                {column: 'contact.updated_at', order: 'ASC'}
            );

            campaign.data.threadData.all = this.transformContacts(campaignContacts.data.contacts);
            campaign.data.threadData.responseLength = campaignContacts.data.total;
        }

        const { data: campaignContactsData } = campaignContacts;
        const {
            total,
            rowsPerPage,
            page,
            numberOfRows,
        } = campaignContactsData;
        let { contacts } = campaignContactsData;
        contacts = this.transformContacts(contacts);

        const getBroadcastCampaignBot = await getCampaignBot(campaignId);
        const { data: campaignBot } = getBroadcastCampaignBot;

        let hasCampaignBot;
        if (!campaignBot) {
            hasCampaignBot = false;
        } else {
            hasCampaignBot = true;
        }
        campaign.hasCampaignBot = hasCampaignBot;

        const campaignData = {
            ...campaign.data,
            hasCampaignBot
        }

        let status = 'finished';
        if (campaign.data.status === false) {
            status = 'open';
        } else if (campaign.data.status === null) {
            status = 'onhold';
        }

        let notificationUsers = campaign.data.users_to_notify || []
       
        this.setState({
            contacts,
            total: campaign.data.threadData.responseLength,
            rowsPerPage,
            page,
            numberOfRows,
            isAdmin,
            campaign: campaignData,
            templates: templates.data,
            groups: groups.data,
            name: campaign.data.name,
            message: campaign.data.message,
            campaignPrivacy: this.handleTransformPrivacy(campaign.data.privacy),
            schedule: campaign.data.schedule,
            timezone: campaign.data.timezone,
            status,
            groupId: campaign.data.group_id,
            isActive: campaign.data.is_active,
            timezones: timezones.data,
            now: moment(),
            totalContacts: campaign.data.noOfContacts || 0,
            notificationUsers,
            no_slots_message: campaign.data.no_slots_message || ''
        });
    };

    transformContacts = (contacts) => {
        // transform only contacts from get-contacts endpoint
        // contacts may contain contactdetails key
        const res = contacts.some((contact) =>
            Object.keys(contact).some(key =>
                key.toLowerCase().startsWith('contactdetails')
            )
        );

        if (!res) return contacts;
        
        const newContactsArr = contacts.map(contact => {
            const { id: contact_id, name, contactDetails } = contact;
            
            const data = { contact_id, name };
            contactDetails.forEach(({ field, value }) => {
                // camelCase to snakeCase
                field = field.split(/(?=[A-Z])/).join('_').toLowerCase();
                data[field] = value;
            });

            return data;
        });

        return newContactsArr;
    }

    handleOnChange = (field, type) => async (event, val1, val2) => {
        const state = {...this.state};

        let value = val1;
        if (type !== 'text') {
            value = val2;
        }

        if (field === 'templateId') {
            state.message = _.find(this.state.templates, {id: value}).details;
        }
        
		state.cursorPosition = event.target.selectionStart;

        state[field] = value;
        this.setState(state, (state) => {
            if(field === 'filter')
                this.updateCampaignStates(this.state, 'filter')
        });
    };

    updateCampaignStates = async (state, flag = '') => {
        const {campaignId} = this.props.match.params;

        // when filter gets updated, start pulling from page 1
        if (flag === 'filter') state.page = 1;

        let paginate = JSON.stringify({
            numberOfRows: state.numberOfRows,
            page: state.page
        });

        let order = (state.sortDirection || this.state.sortDirection).toLowerCase();
        let column = (state.sortBy || this.state.sortBy).toLowerCase();

        switch(column) {
            case 'phone': column = 'mobile'; break;
            case 'message status': column = 'message_status'; break;
            case 'tcpa status': column = 'tcpa'; break;
        }

        try {
            const campaign = await getCampaignById(
                campaignId,
                {"field": this.state.filter},
                paginate,
                {order, column});
            const getBroadcastCampaignBot = await getCampaignBot(campaignId);
            const { data: campaignBot } = getBroadcastCampaignBot;

            let hasCampaignBot;
            if (!campaignBot) {
                hasCampaignBot = false;
            } else {
                hasCampaignBot = true;
            }
            campaign.hasCampaignBot = hasCampaignBot;

            if (!campaign.data.status) {
                // Campaign has not started. Get contacts from get-contact endpoint
                if (column === 'updated_at') column = 'contact.updated_at'
                let campaignContacts = await getContactsInCampaign(campaignId, paginate, {order, column});
                campaign.data.threadData.all = this.transformContacts(campaignContacts.data.contacts);
                campaign.data.threadData.responseLength = campaignContacts.data.total;
            }

            const campaignData = {
                ...campaign.data,
                hasCampaignBot
            }

            let status = 'finished';
            if (campaign.data.status === false) {
                status = 'open';
            } else if (campaign.data.status === null) {
                status = 'onhold';
            }

            session.set(this.state.campaign.id, {
                total: state.total,
                rowsPerPage: state.rowsPerPage,
                page: state.page,
                numberOfRows: state.numberOfRows,
                filter: this.state.filter
            });

            this.setState({
                campaign: campaignData,
                name: campaign.data.name,
                message: campaign.data.message,
                isActive: campaign.data.is_active,
                status,
                total: campaign.data.threadData.responseLength,
                rowsPerPage: state.rowsPerPage,
                page: state.page,
                numberOfRows: state.numberOfRows,
                no_slots_message: campaign.data.no_slots_message || ''
            })
        } catch (error) {
            this.setState({
                showSnackBar: true,
                snackBarMessage: error
            });
        }
    }

    saveCampaign = async () => {
        const state = {...this.state};
        mixpanel.track('broadcast campaign:save campaign');

        if (state.scheduleError !== '') {
            return this.setState({
                showSnackBar: true,
                snackBarMessage: 'Please input valid values'
            });
        }

        const data = {
            name: state.name,
            message: state.message,
            group_id: state.groupId,
            schedule: state.schedule,
            timezone: state.timezone,
            status: state.status,
            privacy: this.handleTransformPrivacy(state.campaignPrivacy, true)
        };

        if (this.state.isAdmin) {
            data.is_active = state.isActive;
        }

        try {
            await updateCampaign(state.campaign.id, data);

            const sessionPageData = (session.get(state.campaign.id) || {});
            let paginate = JSON.stringify({
                numberOfRows: sessionPageData.numberOfRows,
                page: sessionPageData.page
            });
            let campaign = await getCampaignById(
                state.campaign.id,
                {"field": this.state.filter},
                paginate,
                {order: this.state.sortDirection, column: this.state.sortBy}
            );
            campaign = campaign.data;

            state.name = campaign.name;
            state.schedule = campaign.schedule;
            state.timezone = campaign.timezone;
            state.message = campaign.message;
            state.groupId = campaign.group_id;
            state.isActive = campaign.is_active;
            state.campaignPrivacy = this.handleTransformPrivacy(campaign.privacy);
            state.no_slots_message = campaign.no_slots_message || '';

            this.setState({
                ...state,
                isEdit: false,
                showSnackBar: true,
                snackBarMessage: 'Update successful'
            });

            // this.updateRows({...this.state});
        } catch (error) {
            const { message } = error;
            this.setState({
                showSnackBar: true,
                snackBarMessage: message || 'Error in updating campaign'
            });
        }
    }

    setDate = (scheduleDate) => {
        const date = moment(scheduleDate);
        const { isAdmin } = this.state;

        let time = moment(scheduleDate).format('hh:mma');
        time = moment(time, 'hh:mma');

        const lowerLimit = moment('09:00am', 'hh:mma');
        const upperLimit = moment('05:00pm', 'hh:mma');

        // if (!isAdmin) {
        //     if (date.diff(this.state.now, 'days') < 0) {
        //         return this.setState({
        //             schedule: '',
        //             scheduleError: 'Please select date today or a future date'
        //         });
        //     }

        //     if (!(lowerLimit.isBefore(time) && upperLimit.isAfter(time))) {
        //         return this.setState({
        //             scheduleError: 'Schedule time should be in between 9:00AM-5:00PM',
        //             schedule: ''
        //         });
        //     }
        // }

        this.setState({
            schedule: moment(scheduleDate).format('MMM DD, YYYY hh:mm A'),
            scheduleError: ''
        });
    }

	handleClose = () => this.setState({
		showSnackBar: false,
		snackBarMessage : '',
    });

    addMailMerge = (value) => event => {
        const { message, cursorPosition } = this.state;
        mixpanel.track('edit campaign:chip')
        
        // put mailMerge value where the cursor is located
        this.setState({
            message:
                message.substring(0, cursorPosition)
                + value
                + message.substring(cursorPosition, message.length),
            cursorPosition: cursorPosition + value.length
        })
    }

    getCursorPosition = e => {
		const cursorPosition = e.target.selectionStart;
		this.setState({ cursorPosition });
	}

    handleTransformPrivacy = (privacy, toString) => {
        if (toString) {
            return privacy ? 'private' : 'public';
        }
        return privacy === 'private' ? true : false;
    }

    handleFilter = () => {
        const { filter } = this.state;
        switch (filter) {
            case 'sent': 
            this.setState({ filter: 'not sent' });
            break;

            case 'not sent':
            this.setState({ filter: 'none' });
            break;

            default:
            this.setState({ filter: 'sent' });
        }
    }

    handleShowFilterText = (text) => {
        return `(${text[0].toUpperCase()}${text.slice(1)})`;
    }

    showDeleteDialog = () => {
        return this.setState({ showDeleteDialog: true });
    }

    closeDeleteDialog = () => {
        return this.setState({ showDeleteDialog: false });
    }

    handleDeleteCampaign = async () => {
        const { campaign } = this.state;
        const { id } = campaign;

        mixpanel.track(
            'broadcast campaign:delete campaign',
            {data: { id }}
        );

        await deleteCampaign(id)
        .then(() => {
            this.closeDeleteDialog();
            this.setState({
                showSnackBar: true,
                snackBarMessage: 'Campaign successfully deleted'
            });
            this.props.history.push('/campaign');
        })
        .catch(error => {
            const { message = 'There was an error while processing your request' } = error;
            this.closeDeleteDialog();
            this.setState({
                showSnackBar: true,
                snackBarMessage: message
            });
        });
    }

    sortableHeader = (columnName) => {
        let icon =<SwapVert color={grey300}/>;
        let disable = false;

        if (['Message Status'].includes(columnName) &&
            !((this.state.campaign || {}).data || {}).status
        ) {
            return <div> {columnName} </div>
        }

        if(this.state.sortBy === columnName){
          icon = this.state.sortDirection === 'ASC' ? (
            <ArrowUpward color={grey900} />
          ) : (
            <ArrowDownward color={grey900} />
          )
        }

        return (
          <div
            className={this.state.sortBy === columnName ? "sortable-header active" : "sortable-header"}
            onClick={() => this.handleSorterClick(columnName)}
          >
            {columnName} {icon}
          </div>
        )
    }

    handleSorterClick = (columnName) => {
        let state = { ...this.state }

        state.sortBy = columnName
        state.sortDirection =
            this.state.sortDirection === 'ASC' ? 'DESC' : 'ASC'

        this.setState(state, () => {
            this.updateCampaignStates(state)
        })
    }

    listNotificationRecepients = () =>{
        if(this.state.notificationUsers.length === 0){
          return <strong>None.</strong>
        }
        return (
          <ul>
            {this.state.notificationUsers.map((user) => {
              return <li key={user.id}>{user.name} - {user.email}</li>;
            })}
          </ul>
        );
    }

    render = () => {
        let styles = {
            gridFluid: {
                height: "100%",
                backgroundColor: "white",
                overflowY: "auto",
                paddingBottom: "100px"
            },
            paper: {
                padding: '15px',
                marginTop: '15px'
            },
            displayInline: {
                display: 'inline-block'
            },
            displayBlock: {
                display: 'block'
            },
            alert: {
                height: 60,
                padding: '1rem 3rem',
                borderRadius: '5px',
                backgroundColor: red800,
                display: 'flex',
                alignItems: 'center',
                color: 'white'
            },
            alertIcon: {
                marginRight: '1rem',
                color: red100
            },
            campaignActionBtnsSpacing: {
                margin: '0 1rem'
            }
        };

        const templateOptions = this.state.templates.map(template => {
            return (
                <MenuItem
                    key={template.id}
                    value={template.id}
                    primaryText={template.name}
                />
            );
        });

        const groupOptions = this.state.groups.map(group => {
            return (
                <MenuItem
                    key={group.id}
                    value={group.id}
                    primaryText={group.name}
                />
            );
        });

        const timezoneOptions = this.state.timezones.map(zone => {
            return (
                <MenuItem
                key={zone.value}
                value={zone.value}
                primaryText={zone.name}
                />
            );
        });

        const campaignStatusOptions = [
            <MenuItem
                key='open'
                value='open'
                primaryText='Scheduled'
            />,
            <MenuItem
                key='onhold'
                value='onhold'
                primaryText='On Hold'
            />,
            <MenuItem
                key='finished'
                value='finished'
                primaryText='Sent'
                disabled={true}
            />
        ];

        const deleteCampaignActions = [
            <RaisedButton
                label="Yes Delete"
                secondary={true}
                style={styles.campaignActionBtnsSpacing}
                onClick={this.handleDeleteCampaign}
                />,
            <FlatButton
                label="No, Do Not Delete"
                primary={true}
                style={styles.campaignActionBtnsSpacing}
                onClick={this.closeDeleteDialog}
            />
        ]

        const messageStatusOptions = [
            <MenuItem
                key='all'
                value='all'
                primaryText='All'
            />,
            <MenuItem
                key='sent'
                value='sent'
                primaryText='Sent'
            />,
            <MenuItem
                key='not sent'
                value='notSent'
                primaryText='Not sent'
            />,
            <MenuItem
                key='confirmed'
                value='confirmed'
                primaryText='Confirmed'
            />,
            <MenuItem
                key='failedSpam'
                value='failedSpam'
                primaryText='Failed (Spam)'
            />,
            <MenuItem
                key='failed'
                value='failed'
                primaryText='Failed (Unknown)'
            />,
        ];

        let campaignBtn = null;
        if (this.state.campaign.status !== true) {
            campaignBtn = (
                <div>
                    <RaisedButton
                        label="Edit"
                        primary={true}
                        onClick={() => {
                            mixpanel.track('broadcast campaign:edit campaign');
                            this.setState({ isEdit: true })
                        }}
                        disabled={_.isEmpty(this.state.campaign) || this.state.campaign.is_inprogress}
                    />
                </div>
            );
        }
        let campaignBtnStyle = {marginTop: '25px', right: '-20%'};
        if (this.state.isEdit) {
            campaignBtnStyle = {marginTop: '25px', right: '-10%'};
            campaignBtn = <div>
                <RaisedButton
                    label="Delete"
                    secondary={true}
                    style={styles.campaignActionBtnsSpacing}
                    onClick={this.showDeleteDialog}
                    disabled={this.state.campaign.is_inprogress}
                />
                <RaisedButton
                    label="Cancel"
                    color='secondary'
                    style={{marginRight: '15px'}}
                    onClick={() => {
                        const stat = this.state.campaign.status;
                        let status = 'finished';
                        if (stat === false) {
                            status = 'open';
                        } else if (stat === null) {
                            status = 'onhold';
                        }

                        this.setState({
                            isEdit: false,
                            scheduleError: '',
                            name: this.state.campaign.name,
                            schedule: this.state.campaign.schedule,
                            timezone: this.state.campaign.timezone,
                            groupId: this.state.campaign.group_id,
                            status,
                            isActive: this.state.campaign.is_active,
                            message: this.state.campaign.message,
                            no_slots_message: this.state.campaign.no_slots_message || ''
                        })}
                    }
                />
                <RaisedButton
                    label="Save"
                    primary={true}
                    onClick={this.saveCampaign}
                />
            </div>;
        }

        const { campaign } = this.state;
        const { threadData, nontcpa } = campaign;

        let hasCampaignBot;
        if (!_.isEmpty(campaign) && !campaign.hasCampaignBot) {
            hasCampaignBot = (<Paper style={styles.alert} zDepth={1}>
                <InfoIcon style={styles.alertIcon} /> No Campaign Bot
            </Paper>);
        }

        // process broadcast response
        let contacts = threadData && threadData.all.map(entry => {
            // process message status response
            let messageStatusResponse = '';
            const opted = {
                0: 'Opted In',
                1: 'Opted Out'
            }
            const forTCPAEvaluation = {
                optedInDate: entry.opted_in_date,
                optedOutDate: entry.opted_out_date,
                agreement: entry.agreement
            }
            const TCPA = evaluateTCPA(forTCPAEvaluation)

            if (campaign.status) {
                switch(entry.message_status) {
                    case 'delivered':
                        messageStatusResponse = 'Confirmed';
                    break;
                    case 'accepted':
                        messageStatusResponse = 'Sent';
                    break;
                    case 'failed':
                        if (entry.provider_code == '6') {
                            messageStatusResponse = 'Failed (Spam)';
                        } else {
                            messageStatusResponse = 'Failed (Unknown)';
                        }
                        break;
                    case null: case undefined:
                        // checks if the contact has opted out or did not agree
                        if (entry.opted_out_date || ((entry.agreement || '').toLowerCase() === 'no')) {
                            messageStatusResponse = 'Not Sent (Contact Opted Out)';
                        } else if(entry.provider_id){
                            //this confirms that we've sent to vonage but did not get a DLR
                            messageStatusResponse = 'Sent';
                        }else {
                            messageStatusResponse = 'Failed (Unknown)';
                        }
                        break;
                    default:
                        messageStatusResponse = 'Failed (Unknown)';
                        break;
                    }
            }

            return {
              contact_id: entry.contact_id,
              name: entry.name,
              mobile: entry.mobile,
              tcpa: opted[TCPA],
              messageStatusResponse,
            }
        })

        let contactsArray = []
        contacts && contacts.forEach((contact) => {
            if (contact) {
                const {
                    contact_id,
                    mobile,
                    name,
                    tcpa,
                    messageStatusResponse
                } = contact;

                contactsArray.push(
                    <TableRow key={contact_id}>
                        <TableRowColumn><span onClick={this.props.goTo(contact_id)}>{name}</span></TableRowColumn>
                        <TableRowColumn>{formatterUtil.forceFormat(mobile)}</TableRowColumn>
                        <TableRowColumn>{tcpa}</TableRowColumn>
                        <TableRowColumn>
                            {messageStatusResponse}
                        </TableRowColumn>
                    </TableRow>
                );
            }
        });

        const reviewStatusOptions = [
            <MenuItem
                key='approved'
                value={true}
                primaryText='Approved'
            />,
            <MenuItem
                key='pending'
                value={false}
                primaryText='Pending'
            />
        ];

        let reviewStatus = null;
        if (this.state.isAdmin) {
            reviewStatus = (
                <SelectField
                    className="disabled-field"
                    fullWidth={true}
                    floatingLabelText="Review Status"
                    value={this.state.isActive}
                    onChange={this.handleOnChange('isActive', 'select')}
                    disabled={!this.state.isEdit}
                >
                    {reviewStatusOptions}
                </SelectField>
            );
        } else {
            reviewStatus = (
                <TextField
                    className="disabled-field"
                    fullWidth={true}
                    value={this.state.campaign.is_active ? 'Approved' : 'Pending'}
                    floatingLabelText="Review Status"
                    disabled={true}
                />
            );
        }


        const mailMerge = [
            {
                name: 'First Name',
                value: '{{firstname}}'
            },
            {
                name: 'Last Name',
                value: '{{lastname}}'
            },
            {
                name: 'Recruiter Name',
                value: session.get('userData').name,
            },
            {
                name: 'Brand Name',
                value: session.get('userData').companyName,
            },
        ];
        const mailMergeChips = mailMerge.map(mail => {
            return (
                <Chip
                    key={mail.value}
                    style={{ margin: 5 }}
                    onClick={this.addMailMerge(mail.value)}
                >
                    <strong>{mail.name}</strong>
                </Chip>
            );
        });

        let mailMergeElements = '';
        if (this.state.isEdit) {
            mailMergeElements = (
                <div style={styles.displayInline}>
                    <span style={styles.displayInline}>Mail Merge Fields: </span>
                    <div style={styles.displayInline}>
                        <div style={{display: 'flex', flexWrap: 'wrap'}}>{mailMergeChips}</div>
                    </div>
                </div>
            );
        }

        let stats;
        if (campaign.status) {
            const {
                noOfAttempts, msgSent,
                msgDelivered, msgFailed
            } = campaign;

            stats = (
                <Row>
                    {/* <Col xs={4}>
                        <TextField
                            className="disabled-field"
                            fullWidth={true}
                            value={`${msgSent} messages`}
                            floatingLabelText="Msg. Sent"
                            disabled={true}
                        />
                    </Col> */}
                    {/* <Col xs={4}> */}
                    <Col xs={6}>
                        <TextField
                            className="disabled-field"
                            fullWidth={true}
                            value={`${msgDelivered} messages`}
                            floatingLabelText="Msg. Delivered"
                            disabled={true}
                        />
                    </Col>
                    {/* <Col xs={4}> */}
                    <Col xs={6}>
                        <TextField
                            className="disabled-field"
                            fullWidth={true}
                            value={`${msgFailed} messages`}
                            floatingLabelText="Msg. Failed"
                            disabled={true}
                        />
                    </Col>
                </Row>
            );
        }

        return (
			<Grid
                fluid
                className="sitewide-grid-container"
                style={{ overflowX: 'hidden' }}
            >
                <Dialog
                    title="Delete Campaign"
                    actions={deleteCampaignActions}
                    modal={false}
                    open={this.state.showDeleteDialog}
                >
                    Deleting a campaign will delete all messaging in this campaign from being delivered. Are you sure you want to delete this campaign?
                </Dialog>
                <Snackbar
                    open={this.state.showSnackBar}
                    message={this.state.snackBarMessage}
                    autoHideDuration={4000}
                    onRequestClose={this.handleClose}
                />
                <div>
                    <div className="sitewide-title-wrapper">
                        <div className="sitewide-title-container">
                            <h2>Broadcast Campaign Details</h2>
                        </div>
                    </div>
                    <div className="sitewide-page-wrapper height-auto">
                        <div className="sitewide-page-container">
                            <Row>
                                <Col xs={12}>
                                    <Paper style={styles.paper}>
                                        <Row>
                                            <Col xs={12}>{hasCampaignBot}</Col>
                                        </Row>
                                        <Row>
                                            <Col xs={4}>
                                                <TextField
                                                    className="disabled-field"
                                                    fullWidth={true}
                                                    value={this.state.name}
                                                    onChange={this.handleOnChange('name', 'text')}
                                                    floatingLabelText="Campaign Name"
                                                    disabled={!this.state.isEdit}
                                                />
                                            </Col>
                                            <Col xs={4}>
                                                {reviewStatus}
                                            </Col>
                                            <Col xs={4} style={campaignBtnStyle}>
                                                {campaignBtn}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={4}>
                                                <SelectField
                                                    className="disabled-field"
                                                    fullWidth={true}
                                                    floatingLabelText="Group"
                                                    value={this.state.groupId}
                                                    onChange={this.handleOnChange('groupId', 'select')}
                                                    disabled={!this.state.isEdit}
                                                >
                                                    {groupOptions}
                                                </SelectField>
                                            </Col>
                                            <Col xs={2}>
                                                <TextField
                                                    className="disabled-field"
                                                    fullWidth={true}
                                                    value={`${this.state.totalContacts} contacts`}
                                                    floatingLabelText="No. of Contacts"
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col xs={3}>
                                                <DateTimePicker
                                                    className={(this.state.scheduleError === '') ? "disabled-field" : ''}
                                                    fullWidth={true}
                                                    floatingLabelText="Schedule"
                                                    format='MMM DD, YYYY hh:mm A'
                                                    value={this.state.schedule}
                                                    DatePicker={DatePickerDialog}
                                                    TimePicker={TimePickerDialog}
                                                    onChange={this.setDate}
                                                    clearIcon={null}
                                                    disabled={!this.state.isEdit}
                                                    errorText={this.state.scheduleError}
                                                />
                                            </Col>
                                            <Col xs={3}>
                                                <SelectField
                                                    className="disabled-field"
                                                    fullWidth={true}
                                                    floatingLabelText="Schedule timezone"
                                                    value={this.state.timezone}
                                                    onChange={this.handleOnChange('timezone', 'select')}
                                                    disabled={!this.state.isEdit}
                                                >
                                                    {timezoneOptions}
                                                </SelectField>
                                            </Col>
                                        </Row>
                                        {stats}
                                        <Row>
                                            <Col xs={6}>
                                                <SelectField
                                                    fullWidth={true}
                                                    floatingLabelText="Template"
                                                    value={this.state.templateId}
                                                    onChange={this.handleOnChange('templateId', 'select')}
                                                    disabled={!this.state.isEdit}
                                                >
                                                    {templateOptions}
                                                </SelectField>
                                            </Col>
                                            <Col xs={6}>
                                                <SelectField
                                                    className="disabled-field"
                                                    fullWidth={true}
                                                    floatingLabelText="Campaign Status"
                                                    value={this.state.status}
                                                    onChange={this.handleOnChange('status', 'select')}
                                                    disabled={!this.state.isEdit}
                                                >
                                                    {campaignStatusOptions}
                                                </SelectField>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={4} style={{ margin: '1rem 0' }}>
                                                <Checkbox
                                                    label="Private campaign"
                                                    checked={this.state.campaignPrivacy}
                                                    onCheck={this.handleOnChange('campaignPrivacy', 'text')}
                                                    disabled={!this.state.isEdit}
                                                />
                                            </Col>
                                            <Col xs={8}>
                                                <hr/>
                                                <span style={{color:'rgba(0,0,0,0.3)',fontWeight:'700', fontSize:'12px',display:'block'}}>Users to notify of responses</span>
                                                {this.listNotificationRecepients()}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12}>
                                                <h4 style={!this.state.isEdit ? styles.displayInline : styles.displayBlock}>Message:</h4>
                                                {mailMergeElements}
                                                <span style={{...styles.displayInline, marginTop: '15px'}} className='message-count'>{`${this.state.message.length}/${constants.maxMessageLength}`}</span>
                                                <Paper style={{ padding: '10px', }}>
                                                    <TextField
                                                        id='messageTextField'
                                                        className="disabled-field"
                                                        value={this.state.message}
                                                        onChange={this.handleOnChange('message', 'text')}
                                                        fullWidth={true}
                                                        multiLine={true}
                                                        rowsMax={6}
                                                        rows={3}
                                                        maxLength={constants.maxMessageLength}
                                                        autoComplete="off"
                                                        disabled={!this.state.isEdit}
												        onClick={this.getCursorPosition}
													    onKeyDown={this.getCursorPosition}
                                                    />
                                                </Paper>
                                            </Col>
                                        </Row>
                                        {this.state.no_slots_message && (
                                            <Row>
                                                <Col xs={12}>
                                                    <h4>Message shown when no interview slots are available:</h4>
                                                    <Paper style={{ padding: '10px', }}>
                                                        <TextField
                                                            value={this.state.no_slots_message}
                                                            fullWidth={true}
                                                            multiLine={true}
                                                            rowsMax={6}
                                                            rows={3}
                                                            disabled={true}
                                                            className="disabled-field"
                                                        />
                                                    </Paper>
                                                </Col>
                                            </Row>
                                        )}
                                    </Paper>
                                </Col>
                            </Row>
                            <div className="sitewide-card mt-30">
                                <Row>
                                    <Col xs={12}>
                                        <Row>
                                            <Col xs={3}>
                                                <SelectField
                                                    style={{ marginBottom: '15px' }}
                                                    fullWidth={true}
                                                    floatingLabelText="Filter Message Status"
                                                    value={this.state.filter}
                                                    onChange={this.handleOnChange('filter', 'select')}
                                                    disabled={!(this.state.campaign || {}).status}
                                                >
                                                    {messageStatusOptions}
                                                </SelectField>
                                            </Col>
                                        </Row>
                                        <Table className="contacts-table">
                                            <TableHeader
                                                displaySelectAll={false}
                                                adjustForCheckbox={false}
                                            >
                                                <TableRow>
                                                    <TableHeaderColumn>{this.sortableHeader('Name')}</TableHeaderColumn>
                                                    <TableHeaderColumn>{this.sortableHeader('Phone')}</TableHeaderColumn>
                                                    <TableHeaderColumn>{this.sortableHeader('TCPA Status')}</TableHeaderColumn>
                                                    <TableHeaderColumn>
                                                        {this.sortableHeader('Message Status')}
                                                        {/* <span onClick={this.handleFilter} style={{ cursor: 'pointer' }}>
                                                            {`Message Status ${
                                                                this.state.filter === 'none' ? '(No filter)' : this.handleShowFilterText(this.state.filter)
                                                            }`}
                                                        </span> */}
                                                    </TableHeaderColumn>
                                                </TableRow>
                                            </TableHeader>
                                            <TableBody
                                            displayRowCheckbox={false}
                                            >
                                                {contactsArray}
                                            </TableBody>
                                        </Table>
                                        <Divider />
                                        <Pagination
                                            total={this.state.total}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            numberOfRows={this.state.numberOfRows}
                                            updateRows={this.updateCampaignStates.bind(this)}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>
            </Grid>
        );
    };
}

const mapStateToProps = state => {
    return {};
};

const mapDispatchToProps = dispatch => {
    return {
		goTo ( id ) {
			return () => {
				dispatch(push(`/contacts/${id}`));
			}
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewCampaign);
